import axios from "axios";
import {apiCall} from "../../../common/apiActionHandler";

export const getPaymentStatus = (session_id, callback) => (dispatch, getState) => {
    const config = {
        method: 'get',
        url: `/api/stripe/payment_status`,
        params: {session_id}
    };

    apiCall("Fetch payment status", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
